import { useComboCartItems } from '@/talons/combos/useComboCartItems';
import CartActiveCombo from './CartActiveCombo';
import * as S from './styles';

const CartActiveCombos = () => {
    const { activeCombosInCart } = useComboCartItems();

    if (!activeCombosInCart.length) return null;

    return (
        <S.Container>
            {/* <S.SectionTitle>Combos ativos</S.SectionTitle> */}

            {activeCombosInCart.map(({ combo, progress }) => (
                <CartActiveCombo
                    key={combo.id_campanha}
                    activeCombo={{ combo, progress }}
                />
            ))}
        </S.Container>
    );
};

export default CartActiveCombos;
